import { render } from "./wx_mp_auth.vue?vue&type=template&id=5a1b7abe&scoped=true"
import script from "./wx_mp_auth.vue?vue&type=script&lang=js"
export * from "./wx_mp_auth.vue?vue&type=script&lang=js"

import "./wx_mp_auth.vue?vue&type=style&index=0&id=5a1b7abe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b7abe"]])

export default __exports__